import { LitElement, html, css } from 'lit';
import {msg} from '@lit/localize';
import { validateForm,gRecaptcha,hideRevealPassword } from '../../utilities/formsUtilities';
import { accessibility,formStyles } from '../../utilities/styles';
import { eyeSvg } from '../../utilities/icons';
import { EventManager } from '../../utilities/events';
export class AllInLoginForm extends LitElement {
    static properties = {
        action: { type: String },
        nonce: { type: String },
        alreadyLoggedInMessage: { type: String },
        loggedIn: { type: String},
        redirect: { type: String },
        _successMessage: { state: true },
        _errorMessage: { state: true },
        _loginSuccess: { state: true },
        _submitting: { state: true},
    }

    constructor() {
        super();
        this._loginSuccess = false;
        this._errorMessage = '';
        this._submitting = false;
        if(!this.redirect){
            this.redirect = '/';
        }
    }

    connectedCallback() {
        super.connectedCallback();
        if(this.loggedIn=='true'&&this.redirect&&this.redirect!=='/'){
            window.location.href = this.redirect;
        }
        this.eventManager = new EventManager(this);
    }

    get form() {
        return this.shadowRoot.querySelector('form');
    }

    get error() {
        return this.shadowRoot.querySelector('.error');
    }

    get success() {
        return this.shadowRoot.querySelector('.success');
    }

    get formResponse() {
        return this.shadowRoot.querySelector('.message');
    }

    get submitButton() {
        return this.shadowRoot.querySelector('input[type="submit"]');
    }
 
    render() {
        return html` 
            <div class="login-form">
                <slot name="login-form-header"></slot>
                ${this.loggedIn === 'true'
                    ? html`<p>${this.alreadyLoggedInMessage}</p>`
                    : html`
                    <form action="${this.action}" method="post" @submit=${this._login}>
                        <div class="form_inner ${this._loginSuccess?'hide':''}" >
                            <div class="message notice" aria-live="polite"></div>
                            <div class="input-group">
                                <label for="email">${msg('Email')}</label>
                                <input type="email" name="email" id="email" placeholder="${msg('Email')}" aria-required>
                            </div>
                            <input type="text" name="login" id="login" class="hp" autocomplete="off">
                            <div class="input-group">
                                <label for="password">${msg('Password')}</label>
                                <div class="pword_wrapper">
                                    <input type="password" name="password" id="password" placeholder="${msg('Password')}" aria-required>
                                    <button data-switch="password" aria-label="${msg('Show password')}" aria-pressed="false" type="button" class="show-password" @click=${hideRevealPassword}>
                                    ${eyeSvg}${msg('Show password')}</button>
                                </div>
                            </div>
                            <input type="submit" value="${msg('Log in')}">
                        </div>
                        <div class="notice" aria-live="assertive">
                            <div class="${this._errorMessage?'':'hide'} error"></div>
                            <div class="${this._loginSuccess?'':'hide'} success"></div>
                            <slot name="login-success" class="${this._loginSuccess?'':'hide'} success"></slot>
                        </div>
                        <div class="${this._loginSuccess?'hide':''}">
                            <slot></slot>
                        </div>
                    </form>
                `}
            </div>
        `
    }

    async _login(e) {
        e.preventDefault();
        //block duplicates calls to rest.php
        if(this._submitting) return;
        this._submitting = true;
        this._errorMessage = '';
        let valid = validateForm(this.form,this.formResponse);
        if(!valid) {
            this._submitting = false;
            return;
        }
        let formData = new FormData(this.form);
        
        formData = JSON.stringify(Object.fromEntries(formData));
        this.form.classList.add('loading');
        this.submitButton.disabled = true;
        this.form.setAttribute('aria-busy', 'true');
        
       /*  let gTokenValid  = await gRecaptcha(this.formResponse,this.action,this.nonce); 
        if(!gTokenValid){
            this.form.classList.remove('loading');
            this.form.setAttribute('aria-busy', 'false');
            this.submitButton.disabled = false;
            this._submitting = false;
            return;
        } */
        let response = await fetch(this.action, {
            method: 'POST',
            body: formData,
            headers: {
                'Content-Type': 'application/json',
                'AllIn-Nonce': this.nonce,
                'AllIn-Login': 'login',
            }
        })
        try{
            response = await response.json();
            if(response.ok){
                /* this.form.classList.remove('loading');
                this.form.setAttribute('aria-busy', 'false');
                this._loginSuccess = true;
                this.success.innerHTML = response.message; */
                this._dispatchLoginEvent(response.name);

                if(!this.redirect){
                    window.location.href = response.redirect;
                }
                else{
                    window.location.href = this.redirect;
                }
            }
            else{
                this.error.innerHTML = response.message;
                this._errorMessage = true;
                this.form.classList.remove('loading');
                this.form.setAttribute('aria-busy', 'false');
                this.submitButton.disabled = false;
            }
        }
        catch(error){
            console.error('Error:', error);
        }

        this._submitting = false;
    }

    _dispatchLoginEvent(name) {
        this.eventManager.emit('allin-login', { loggedIn: true, name: name });
    }

    static styles = [
        accessibility,
        formStyles,
        css`
            .login-form{
                background-color:var(--allin-bg-color,transparent);
                padding:var(--allin-padding,2rem);
                width:680px;
                max-width:85vw;
                margin:0 auto;
                box-sizing:border-box;
            }

        `
    ]
}


